import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "ask-category-removal-window" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HakoLabelControl = _resolveComponent("HakoLabelControl")!
  const _component_HakoButton = _resolveComponent("HakoButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.chosenCategory)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, "Haluatko varmasti poistaa kategorian " + _toDisplayString(_ctx.chosenCategory.name), 1),
          (_ctx.chosenCategory.guides.length > 0 || _ctx.chosenCategory.children.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, " ja sen ohjeet / alikategoriat:"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenCategory.children, (category) => {
            return (_openBlock(), _createElementBlock("b", {
              key: category.id
            }, _toDisplayString(category.name), 1))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenCategory.guides, (guide) => {
            return (_openBlock(), _createElementBlock("p", {
              key: guide.id
            }, _toDisplayString(guide.name), 1))
          }), 128)),
          _createVNode(_component_HakoLabelControl, {
            label: "Kyllä",
            for: "sure"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                name: "sure",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isSure) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.isSure]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_HakoButton, {
            onClick: _withModifiers(_ctx.deleteCategory, ["prevent"]),
            disabled: !_ctx.isSure
          }, {
            default: _withCtx(() => [
              _createTextVNode("Poista")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}